var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00247 19H4.99118C4.44956 19 4 18.5543 4 18.0046V9H6V15.4966C6 15.7671 6.2232 16 6.49852 16H7V6.00684C7 5.45077 7.45576 5 8.00247 5H17.9975C18.5512 5 19 5.44994 19 6.00684V17.5018C19 18.3292 18.3204 19 17.5045 19H8.00247ZM10 11.5095V8.49048C10 8.21959 10.2279 8 10.491 8H15.509C15.7802 8 16 8.21506 16 8.49048V11.5095C16 11.7804 15.7721 12 15.509 12H10.491C10.2198 12 10 11.7849 10 11.5095ZM10 13.5C10 13.7681 10.2198 14 10.491 14H15.509C15.7721 14 16 13.7761 16 13.5C16 13.2319 15.7802 13 15.509 13H10.491C10.2279 13 10 13.2239 10 13.5ZM10.4905 16C10.2196 16 10 15.7681 10 15.5C10 15.2239 10.2151 15 10.4905 15H13.5095C13.7804 15 14 15.2319 14 15.5C14 15.7761 13.7849 16 13.5095 16H10.4905Z",
    fill: "#10B981"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNews);
export default __webpack_public_path__ + "static/media/icon-news.14621b349da64305e76f27a94ec85fe4.svg";
export { ForwardRef as ReactComponent };